import axios from "axios";
import Vue from 'vue';
import VueSax from 'vuesax';
import 'vuesax/dist/vuesax.css';

Vue.use(VueSax);

const api = (context) => {
    // console.log('api', context);
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + context.getters["auth/token"];
    axios.interceptors.request.use(
        function (config) {
            // Tu lógica personalizada aquí antes de que se envíe la solicitud
            // console.log('Antes de la solicitud:', config);
        
            // Asegúrate de devolver la configuración para que la solicitud continúe
            return config;
        },
        function (error) {
            // Manejo de errores de solicitudes
            return Promise.reject(error);
        }
    );
    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if(error.response.data.message){
            console.log('Error message', error.response.data.message);
            if(error.response.data.message === 'Unauthenticated.'){
                // set_loading(false);
                const vueInstance = new Vue();
                vueInstance.$vs.notify({
                    title:'Error',
                    text: 'Ha habido un error de login. Por favor, cierra la sesión y vuelve a entrar.',
                    color:'danger'
                });
                vueInstance.$vs.loading.close();
            }
        }
        return Promise.reject(error);
    });
    return axios;
}

export default api;